export type RentalData = {
  from: string;
  until: string;
  people: Array<RentalDataPerson>;
};

export type RentalDataPerson = {
  configuration: string;
  experience: string;
  firstName: string;
  height: number;
  remarks: string;
  shoeSize: string;
  weight: string;
};

export type RentalPerson = {
  id: number;
  birthYear: string;
  checkHeightAndWeight: boolean;
  firstName: string;
  height: string;
  primary: boolean;
  proficiencyId: string;
  shoeSize: string;
  weight: string;
  placeholderHeight?: string;
  placeholderWeight?: string;
};

export type RentalFormValues = {
  period: string;
  people: Array<RentalPerson>;
};

export type RentalProficiency = {
  id: number;
  code: string;
  translation?: string;
};
